import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  OutlinedInput,
  Stack,
  Chip,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import { createSlug } from "../config/slug-config";
import { useSelector } from "react-redux";
const names = [
  "Humaira Sims",
  "Santiago Solis",
  "Dawid Floyd",
  "Mateo Barlow",
  "Samia Navarro",
  "Kaden Fields",
  "Genevieve Watkins",
  "Mariah Hickman",
  "Rocco Richardson",
  "Harris Glenn",
];
export default function FormDialogs({
  open,
  setOpen,
  formData,
  addUpdate,
  handleFormCreate,
  setRole,
  role,
  rowData,
  subsdiaryRowData,
  setFormData,
}) {
  // const {
  //   register,
  //   control,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm({});
  const [selectedNames, setSelectedNames] = useState([]);
  const [selectedSubsidiary, setSelectedSubsidiary] = useState([]);

  // const [formD, setFormData] = useState({});
  const { data: user } = useSelector((state) => state.user);
  const [error, seterror] = useState({
    email: false,
    name: false,
  });

  useEffect(() => {
    if (
      user.token &&
      selectedNames.length === 0 &&
      selectedSubsidiary.length === 0 &&
      open &&
      addUpdate === "UPDATE"&&
      formData?.role==="user"
    ) {
      setSelectedNames(
        JSON.parse(formData?.page_access?.replace("{", "[")?.replace("}", "]"))
      );
      const subsidiaryData = formData?.subsidiary;
      if (subsidiaryData) {
        setSelectedSubsidiary(
          JSON.parse(subsidiaryData.replace("{", "[")?.replace("}", "]"))
        );
      }
    }
  }, [user.token, open, selectedNames, selectedSubsidiary]);

  useEffect(() => {
    // setData(selectedNames?.map((el) => createSlug(el)));

    setFormData({
      ...formData,
      page_access: selectedNames,
      subsidiary: selectedSubsidiary,
    });
  }, [selectedNames, selectedSubsidiary]);
  const HandelSelect = (event) => {
    setSelectedNames(event.target.value);
  };
  const HandelSelectSubsidiary = (event) => {
    setSelectedSubsidiary(event.target.value);
  };

  const HandleOnchange = (event) => {
    const { value, name } = event.target;
    if (value.includes("@")) {
      seterror({ ...error, email: false });
    }
    if (formData?.name) {
      seterror({ ...error, name: false });
    }
    setFormData({ ...formData, [name]: value });
  };
console.log(formData,"formD")
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle variant="h2">Add/Edit Account</DialogTitle>
      <Box
        component="form"
        onSubmit={(e) => {
          handleFormCreate(
            e,
            formData,
            setSelectedNames,
            setSelectedSubsidiary,
            setFormData
          );
        }}
      >
        <DialogContent>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  defaultValue={formData?.name}
                  name="name"
                  label="Name"
                  // value={cost_code}
                  onChange={(e) => {
                    HandleOnchange(e);
                  }}
                  variant="outlined"
                  fullWidth
                  // inputRef={register({
                  //   required: "Name is required.",
                  // })}
                  // error={Boolean(errors.name)}
                  // helperText={errors.name?.message}
                  required
                  shrink
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  defaultValue={formData?.email}
                  name="email"
                  label="Email"
                  type="email"
                  // value={type}
                  onChange={(e) => {
                    HandleOnchange(e);
                  }}
                  variant="outlined"
                  fullWidth
                  // inputRef={register({
                  //   required: "E-mail is required.",
                  //   pattern: {
                  //     value:
                  //       /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  //     message: "Please enter a valid e-mail address.",
                  //   },
                  // })}

                  required
                  shrink
                  disabled={addUpdate === "UPDATE" ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl
                  fullWidth
                  // error={Boolean(errors.role)}
                  required
                  shrink
                >
                  <InputLabel size="small" id="demo-simple-select-label-a">
                    Role
                  </InputLabel>
                  {/* <Controller
                    defaultValue={formData?.role}
                  
                    
                    render={(props) => ( */}
                  <Select
                    size="small"
                    defaultValue={formData?.role}
                    onChange={(e) => {
                      setRole(e.target.value);
                      HandleOnchange(e);
                    }}
                    label="Role"
                    name="role"
                  >
                    <MenuItem value="admin">Admin</MenuItem>
                    <MenuItem value="user">User</MenuItem>
                  </Select>
                  {/* )}
                    name="role"
                    control={control}
                    rules={{
                      required: "Please select role",
                    }}
                  /> */}
                  {/* <FormHelperText>{errors.role?.message}</FormHelperText> */}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}></Grid>
              <Grid item xs={12} sm={6}>
                {role === "user" && (
                  <FormControl required fullWidth>
                    <InputLabel>Transaction Type</InputLabel>
                    <Select
                      multiple
                      name="page_access"
                      value={selectedNames}
                      onChange={HandelSelect}
                      input={<OutlinedInput label="Multiple Select" />}
                      renderValue={(selected) => (
                        <Stack gap={1} direction="row" flexWrap="wrap">
                          {selected?.map((value) => (
                            <Chip
                              key={value}
                              label={value}
                              onDelete={() =>
                                setSelectedNames(
                                  selectedNames.filter((item) => item !== value)
                                )
                              }
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) =>
                                    event.stopPropagation()
                                  }
                                />
                              }
                            />
                          ))}
                        </Stack>
                      )}
                    >
                      {rowData?.data?.map((name) => (
                        <MenuItem
                          key={name.fullname}
                          value={name.fullname}
                          sx={{ justifyContent: "space-between" }}
                        >
                          {name.fullname}
                          {selectedNames.includes(name.fullname) ? (
                            <CheckIcon color="info" />
                          ) : null}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                {role === "user" && (
                  <FormControl required fullWidth>
                    <InputLabel>Subsidiary</InputLabel>
                    <Select
                      multiple
                      name="subsidiary"
                      value={selectedSubsidiary}
                      onChange={HandelSelectSubsidiary}
                      input={<OutlinedInput label="Multiple Select" />}
                      renderValue={(selected) => (
                        <Stack gap={1} direction="row" flexWrap="wrap">
                          {selected?.map((value) => (
                            <Chip
                              key={value}
                              label={value}
                              onDelete={() =>
                                setSelectedSubsidiary(
                                  selectedSubsidiary.filter(
                                    (item) => item !== value
                                  )
                                )
                              }
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) =>
                                    event.stopPropagation()
                                  }
                                />
                              }
                            />
                          ))}
                        </Stack>
                      )}
                    >
                      {subsdiaryRowData?.data?.map((name) => (
                        <MenuItem
                          key={name.name}
                          value={name.name}
                          sx={{ justifyContent: "space-between" }}
                        >
                          {name.name}
                          {selectedSubsidiary.includes(name.name) ? (
                            <CheckIcon color="info" />
                          ) : null}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            className="cancel-button"
            onClick={() => {
              setSelectedSubsidiary([]);
              setSelectedNames([]);
              setFormData({});
              setOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className="submit-button"
            type="submit"
            // onClick={handleSubmit(handleFormCreate)}
          >
            {addUpdate}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
